import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'aftp-form-error-title',
  templateUrl: './form-error-title.component.html',
  styleUrls: ['./form-error-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormErrorTitleComponent {}
